



















































import Vue from 'vue'
import {areaTelNameList, getTelNumber, getTelClinic} from '../config';

export default Vue.extend({
  name: 'Contact',
  data() {
    return {
      area: 'tokyo',
      areaTelName: 'tokyo',
    }
  },
  computed: {
    clinic(){
      return getTelClinic(this.area);
    },
    tel() {
      // URLにエリアが入っていたら電話番号変更
      areaTelNameList.forEach((item, i) => {
        if (location.href.indexOf(item) !== -1) {
          this.areaTelName = item;
        }
      });
      return getTelNumber(this.areaTelName);
    }
  },
  methods: {
    conversionTel(){
      window.FD.conversionTelButtonCountLabel(this.area)
    }
  }
})
